import { lazy } from 'react';

// Auth and Help Center
export const LazyLogin = lazy(() => import('../features/Yucollect/Login'));
export const LazyHCHome = lazy(
  () => import('../features/Yucollect/HelpCentre')
);
export const LazyHCFaqs = lazy(
  () => import('../features/Yucollect/HelpCentre/faqs')
);
export const LazyHCGlossaries = lazy(
  () => import('../features/Yucollect/HelpCentre/glossaries')
);
export const LazyHCReleaseNotes = lazy(
  () => import('../features/Yucollect/HelpCentre/release-notes')
);
export const LazyHCVideoGuides = lazy(
  () => import('../features/Yucollect/HelpCentre/video-guides')
);

// Dashboards
export const LazyAgentDashboard = lazy(
  () =>
    import(
      '../features/Yucollect/Dashboards/SupervisorDashboard/AgentDashboard'
    )
);
export const LazyAllPortfolios = lazy(
  () => import('../features/Yucollect/Dashboards/AllPortfolios')
);
export const LazySupervisorDashboard = lazy(
  () =>
    import(
      '../features/Yucollect/Dashboards/SupervisorDashboard/SupervisorDashboard'
    )
);
export const LazyAgentPerformance = lazy(
  () => import('../features/Yucollect/Dashboards/AllAgentPerformance')
);
export const LazyOneView = lazy(
  () => import('../features/Yucollect/Dashboards/OneView')
);
export const LazyField = lazy(
  () => import('../features/Yucollect/Dashboards/Field')
);
export const LazyCall = lazy(
  () => import('../features/Yucollect/Dashboards/Call')
);
export const LazyDigital = lazy(
  () => import('../features/Yucollect/Dashboards/Digital')
);
export const LazyFieldSupervisorDashboard = lazy(
  () => import('../features/Yucollect/Dashboards/FieldSupervisorDashboard')
);

// Consolidated Dashboard (Allocator)
export const LazyConsolidatedDashboardWrapper = lazy(
  () =>
    import(
      '../features/Yucollect/ConsolidatedDashboard/ConsolidatedDashboardWrapper'
    )
);
export const LazyConsolidatedOneView = lazy(
  () => import('../features/Yucollect/ConsolidatedDashboard/OneView')
);
export const LazyDispositionDetail = lazy(
  () => import('../features/Yucollect/ConsolidatedDashboard/DispositionDetail')
);
export const LazyCallDashboard = lazy(
  () => import('../features/Yucollect/ConsolidatedDashboard/CallDashboard')
);
export const LazyFieldDashboard = lazy(
  () => import('../features/Yucollect/ConsolidatedDashboard/FieldDashboard')
);
export const LazyDigitalDashboard = lazy(
  () => import('../features/Yucollect/ConsolidatedDashboard/DigitalDashboard')
);

// Agency related
export const LazyDiscoveryContainer = lazy(
  () => import('../features/Yucollect/Discovery')
);
export const LazyVendorDetail = lazy(
  () => import('../features/Yucollect/Discovery/VendorDetail')
);
export const LazyAgencies = lazy(
  () => import('../features/Yucollect/Agencies')
);
export const LazyAgencyMonitorPage = lazy(
  () => import('../features/Yucollect/AgencyMonitor/AgencyMonitorPage')
);
export const LazyAgencyOnboardingIndex = lazy(
  () => import('../features/Yucollect/AgencyOnboarding/Create')
);
export const LazyAgencyProfileAllocatorDocument = lazy(
  () =>
    import('../features/Yucollect/AgencyOnboarding/Profile/AllocatorDocument')
);
export const LazyAgencyProfileDiscovery = lazy(
  () => import('../features/Yucollect/AgencyOnboarding/Profile/Discovery')
);
export const LazyAgencyProfileYucollectDocument = lazy(
  () =>
    import('../features/Yucollect/AgencyOnboarding/Profile/YucollectDocument')
);
export const LazyAgencySignIn = lazy(
  () => import('../features/Yucollect/AgencyOnboarding/SignIn')
);
export const LazyAgencySignUp = lazy(
  () => import('../features/Yucollect/AgencyOnboarding/SignUp')
);

// Agency Onboarding V2
export const LazyAgencyOnboardingV2 = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2')
);
export const LazyAgencyCreated = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2/AgencyCreated')
);
export const LazyAgencyProfile = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2/ProfilePage')
);
export const LazyProfileRegistered = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2/ProfileRegistered')
);
export const LazyRegister = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2/Register')
);
export const LazySignUp = lazy(
  () => import('../features/Yucollect/AgencyOnboardingV2/SignUp')
);

// Campaign related
export const LazyCampaigns = lazy(
  () => import('../features/Yucollect/Campaign/Campaigns')
);
export const LazyCreateCampaign = lazy(
  () => import('../features/Yucollect/Campaign/components/CreateCampaign')
);
export const LazyEditCampaign = lazy(
  () => import('../features/Yucollect/Campaign/components/EditCampaign')
);
export const LazyCampaignAllocationSummary = lazy(
  () =>
    import(
      '../features/Yucollect/CampaignAllocationSummary/CampaignAllocationSummary'
    )
);

// Agent related
export const LazyAgentMaster = lazy(
  () => import('../features/Yucollect/AgentOnboarding/List/AgentMaster')
);
export const LazyBulkOnboard = lazy(
  () =>
    import(
      '../features/Yucollect/AgentOnboarding/Create/BulkOnboard/BulkOnboard'
    )
);
export const LazyOnboardingIndex = lazy(
  () => import('../features/Yucollect/AgentOnboarding/Create')
);
export const LazyMapAgentToCampaign = lazy(
  () =>
    import(
      '../features/Yucollect/AgentOnboarding/AgentGroup/MapAgentToCampaign/MapAgentToCampaign'
    )
);

// CRM related
export const LazyCRMDashboard = lazy(
  () => import('../features/Yucollect/CRM/Dashboard/Dashboard')
);
export const LazyMissedcalls = lazy(
  () => import('../features/Yucollect/CRM/MissedCalls')
);
export const LazyPriorityTasks = lazy(
  () => import('../features/Yucollect/CRM/PriorityTasks')
);
export const LazyWhatsappMessages = lazy(
  () => import('../features/Yucollect/CRM/WhatsappMessages')
);
export const LazyBorrowerDetails = lazy(
  () => import('../features/Yucollect/CRM/BorrowerDetails/BorrowerDetails')
);

// Allocation related
export const LazyUploadAllocation = lazy(
  () => import('../features/Yucollect/UploadAllocation/UploadAllocation')
);
export const LazyAllocationList = lazy(
  () =>
    import('../features/Yucollect/AllocationList/AllocationList/AllocationList')
);
export const LazyAllocationColumnMapping = lazy(
  () =>
    import(
      '../features/Yucollect/Settings/AllocationMapping/AllocationColumnMapping/AllocationColumnMapping'
    )
);
export const LazyExtractionSetup = lazy(
  () => import('../features/Yucollect/Settings/Loanbook/ExtractionSetup')
);
export const LazyLoanBookSetup = lazy(
  () => import('../features/Yucollect/Settings/Loanbook/LoanBookSetup')
);
export const LazyDerivedFields = lazy(
  () => import('../features/Yucollect/Settings/Loanbook/DerivedFields')
);
export const LazyPaymentList = lazy(
  () => import('../features/Yucollect/AllocationList/PaymentList/PaymentList')
);
export const LazyBulkPaymentHistory = lazy(
  () =>
    import(
      '../features/Yucollect/AllocationList/BulkPaymentHistory/BulkPaymentHistory'
    )
);
export const LazyAllocatorAllocationList = lazy(
  () =>
    import(
      '../features/Yucollect/AllocationList/AllocatorAllocationList/AllocatorAllocationList'
    )
);

// Digital & Call planner related
export const LazyDigitalSummary = lazy(
  () => import('../features/Yucollect/Digital/DigitalSummary/DigitalSummary')
);
export const LazyDigitalPlanner = lazy(
  () => import('../features/Yucollect/Digital/DigitalPlanner/DigitalPlanner')
);
export const LazyCallPlannerPage = lazy(
  () => import('../features/Yucollect/CallPlanner/CallPlanner')
);
export const LazyCallPlannerSummary = lazy(
  () =>
    import(
      '../features/Yucollect/CallPlanner/components/CallPlannerSummary/CallPlannerSummary'
    )
);
export const LazyFieldPlanner = lazy(
  () =>
    import(
      '../features/Yucollect/FieldPlanner/FieldAgentAssignment/FieldAgentAssignment'
    )
);
export const LazyGroupChannelPlannerPage = lazy(
  () => import('../features/Yucollect/GroupChannelPlanner/GroupChannelPlanner')
);
export const LazyChannelPlannerSummary = lazy(
  () =>
    import('../features/Yucollect/ChannelPlannerSummary/ChannelPlannerSummary')
);

// Content related
export const LazyContentTemplate = lazy(
  () => import('../features/Yucollect/Content/Channels/ContentTemplate')
);
export const LazyOverview = lazy(
  () => import('../features/Yucollect/Content/Channels/Overview')
);
export const LazyTemplateDetails = lazy(
  () => import('../features/Yucollect/Content/Channels/TemplateDetails')
);
export const LazyContent = lazy(
  () => import('../features/Yucollect/Content/Content')
);

// Settings related
export const LazySettings = lazy(
  () => import('../features/Yucollect/Settings')
);
export const LazyProfile = lazy(
  () => import('../features/Yucollect/Settings/Profile')
);
export const LazyDIDConfiguration = lazy(
  () => import('../features/Yucollect/Settings/Configuration/DIDConfiguration')
);
export const LazyLocationPreferences = lazy(() => {
  return import(
    '../features/Yucollect/Settings/Preferences/LocationPreferencesView'
  ).then((module) => ({ default: module.LocationPreferences }));
});
export const LazyProductPreferences = lazy(
  () =>
    import('../features/Yucollect/Settings/Preferences/ProductPreferencesView')
);
export const LazyBucketPreferences = lazy(
  () =>
    import('../features/Yucollect/Settings/Preferences/BucketPreferencesView')
);
export const LazyChannelPreferences = lazy(
  () =>
    import('../features/Yucollect/Settings/Preferences/ChannelPreferenceView')
);
export const LazyPaymentPreferences = lazy(
  () => import('../features/Yucollect/Settings/Preferences/PaymentPreferences')
);
export const LazyContentPreferences = lazy(
  () => import('../features/Yucollect/Settings/Preferences/ContentPreferences')
);

// User Management
export const LazyEmployeeProfile = lazy(
  () => import('../features/Yucollect/Settings/UserManagment/EmployeeProfile')
);
export const LazyEditedEmployeeProfile = lazy(
  () =>
    import(
      '../features/Yucollect/Settings/UserManagment/EmployeeProfile/components/EditedEmployeeProfile'
    )
);
export const LazyHierarchySetup = lazy(
  () => import('../features/Yucollect/Settings/UserManagment/HierarchySetup')
);
export const LazyDesignationSetup = lazy(
  () => import('../features/Yucollect/Settings/UserManagment/DesignationSetup')
);

// CRM components
export const LazyCallStateManager = lazy(() =>
  import('../features/Yucollect/CRM/components/CallStateManager').then(
    (module) => ({ default: module.CallStateManager })
  )
);

// Misc
export const LazyPricing = lazy(
  () => import('../features/Yucollect/Pricing/Pricing')
);
export const LazyAllocators = lazy(
  () => import('../features/Yucollect/Allocators')
);
export const LazyIncentiveProgram = lazy(
  () => import('../features/Yucollect/Incentive')
);
export const LazyProgramConfigurator = lazy(
  () => import('../features/Yucollect/Incentive/components/ProgramConfigurator')
);
export const LazyOutreachConfig = lazy(
  () => import('../features/OutreachConfig')
);
export const LazyStrategyConfig = lazy(
  () => import('../features/StrategyConfig/StrategyConfig')
);
export const LazyReportsWrapper = lazy(() => {
  return import('../features/Yucollect/Reports/ReportsWrapper').then(
    (module) => ({ default: module.ReportsWrapper })
  );
});

// Compliance related
export const LazyAgencyDashboard = lazy(
  () => import('../features/Yucollect/Compliance/Dashboard')
);
export const LazyAllAgencies = lazy(
  () => import('../features/Yucollect/Compliance/AllAgencies')
);
export const LazyAgencyDetailPage = lazy(
  () => import('../features/Yucollect/Compliance/AgencyDetails')
);
export const LazyMyDocuments = lazy(
  () => import('../features/Yucollect/Compliance/MyDocuments')
);
export const LazyDocumentDetail = lazy(
  () => import('../features/Yucollect/Compliance/MyDocuments/DocumentDetail')
);
export const LazyMyAgencies = lazy(
  () => import('../features/Yucollect/Compliance/MyAgencies')
);
export const LazyAgencyDetails = lazy(
  () => import('../features/Yucollect/Compliance/MyAgencies/AgencyDetails')
);
export const LazyAgencyDetailList = lazy(
  () => import('../features/Yucollect/Compliance/Recordings/AgencyDetailList')
);
export const LazyRecordingsByYear = lazy(
  () => import('../features/Yucollect/Compliance/Recordings/RecordingsByYear')
);
export const LazyRecordingsByMonth = lazy(
  () => import('../features/Yucollect/Compliance/Recordings/RecordingsByMonth')
);

// Operations Admin
export const LazyOperationsLayout = lazy(
  () => import('../features/Yucollect/OpsAdminConfig/OperationsLayout')
);
export const LazyOpsColumnMappingList = lazy(
  () => import('../features/Yucollect/OpsAdminConfig/OpsColumnMappingList')
);
export const LazyOpsColumnMappingForm = lazy(
  () => import('../features/Yucollect/OpsAdminConfig/OpsColumnMappingForm')
);
export const LazyOpsColumnMappingEditForm = lazy(
  () => import('../features/Yucollect/OpsAdminConfig/OpsColumnMappingEditForm')
);
export const LazyOpsSystemUsers = lazy(
  () =>
    import('../features/Yucollect/OpsAdminConfig/OpsSystemUsers/OpsSystemUsers')
);
export const LazyAgencyList = lazy(
  () => import('../features/Yucollect/Admin/Onboarding/Agency/AgencyList')
);
export const LazyVendorManagement = lazy(
  () => import('../features/Yucollect/Admin/VendorManagement/VendorManagement')
);

// Score
export const LazyScore = lazy(
  () => import('../features/Yucollect/Score/Score')
);
export const LazyUploadScore = lazy(
  () => import('../features/Yucollect/UploadScore/UploadScore')
);

// Layouts
export const LazyCRMLayout = lazy(() => import('./layouts/CRMLayout'));
export const LazyReportsLayout = lazy(() => import('./layouts/ReportsLayout'));
export const LazyConfigurationWrapper = lazy(
  () => import('./layouts/ConfigurationWrapper')
);

// Utility components
export const LazyComingSoon = lazy(
  () => import('../components/ComingSoon/ComingSoon')
);
export const LazyPageNotFound = lazy(
  () => import('../components/PageNotFound/PageNotFound')
);
export const LazyColumnMappingWrapper = lazy(() => {
  return import(
    '../features/Yucollect/Settings/AllocationMapping/components/ColumMappingWrapper'
  ).then((module) => ({ default: module.ColumnMappingWrapper }));
});
